import { useEffect, useState } from "react";
import api from "../../api/api";
import ntactlogo from "../../assets/Ntact.png";

const CompanyDetails = ({
  selectedCompany,
  setSelectedCompany,
  setSelectedEmployee,
  selectedemployee,
  isAppAccess,
  setIsAppAccess,
  employeeId,
  setToastSeverity,
  setOpenToast,
  setToastMessage,
  setEmployeeId,
  companylist,
  setScreen,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  // format company labels
  const formatLabel = (name) => {
    switch (name.toUpperCase()) {
      case "CONSTRUCTION":
        return "Construction";
      case "ENGINEERING":
        return "Engineering";
      case "INSTRUMENTATION & ELECTRICAL (I&E)":
        return "Instrumentation & Electrical (I&E)";
      default:
        return name;
    }
  };

  // ✅ Fetch employee suggestions
  const searchEmployee = async (query) => {
    if (!query.trim() || !selectedCompany?.id) {
      setSuggestions([]);
      return;
    }
    try {
      setLoading(true);
      const response = await api.get(`/v1/timesheets/get-employee`, {
        params: {
          empid: query,
          company_id: selectedCompany.id,
        },
      });

      if (response.status === 200) {
        setSuggestions(response.data || []);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error(error);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Debounce API call when employeeId changes
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (employeeId) {
        searchEmployee(employeeId);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [employeeId, selectedCompany]);

  const isFormValid =
    selectedCompany?.id && selectedemployee && employeeId.trim().length > 0;
const checkemployeeExistance=async()=>{
  try {
    setLoading(true)

    const response =await api.get(`/v1/onboarding-employee/${employeeId}?company_id=${ selectedCompany?.id}`)
   if (response.status === 200) {
  console.log("✅ API call successful:", response);

  const empId = Number(response.data?.employee_details?.company_id);
  const companyId = Number(selectedCompany?.id);

  console.log("🔎 Comparing IDs:", { empId, companyId });

  if (empId === companyId) {
    console.log("⚠️ Employee ID already registered");

    setToastMessage('Employee ID is already registered');
    setToastSeverity('info');
    setOpenToast(true);
  } else {
    console.log("➡️ Moving to screen 1 (IDs do not match)");
    console.log(isAppAccess,'iss')
    if(isAppAccess){
setScreen(5)
    }else{
    setScreen(1);
    }

  }
} else {
  console.log("❌ API call failed, status:", response.status);
     if(isAppAccess){
setScreen(5)
    }else{
    setScreen(1);
    }
}

  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)
  }
}
  return (
    <div
      className="w-auto sm:w-[400px] h-auto bg-white text-start border p-6 relative"
      style={{
        borderRadius: "12.75px",
        boxShadow: "0 0 4px 0 rgba(179, 67, 67, 0.5)",
        borderColor: "rgba(179, 67, 67, 0.2)",
      }}
    >
      <div className="flex justify-center mb-4">
        <img src={ntactlogo} alt="NTact Logo" className="w-28" />
      </div>
      <h2 className="text-center text-xl font-semibold text-[#0A0A0A]">
        Face Recognition Setup
      </h2>
      <p className="text-center text-sm text-[#717182] mb-4">
        Search for employee to begin face capture
      </p>

      {/* Company selection */}
      <div className="mb-4 text-[#0A0A0A] font-semibold">
        <label className="block mb-2">Select company</label>
        <div className="flex flex-col gap-4">
          {companylist.map((company) => (
            <label key={company.id} className="inline-flex items-center cursor-pointer">
              <input
                type="radio"
                className="form-radio accent-[rgba(179,67,67,1)]"
                value={company.name}
                checked={selectedCompany?.id === company.id}
                onChange={() => {
                  setSelectedCompany(company)
                setSuggestions([])
                setSelectedEmployee('')
                setEmployeeId('')
                }
                              }              />
              <span className="ml-2">{formatLabel(company.name)}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Employee ID input with suggestions */}
      <div className="mb-2 relative">
        <label className="block font-semibold mb-2 text-[#0A0A0A]">
          Employee ID
        </label>
        <input
          type="text"
          value={employeeId}
          onChange={(e) => {
              const val = e.target.value.replace(/\D/g, ''); // Only keep numbers
    setEmployeeId(val);

            setSelectedEmployee(null); // reset if user edits
          }}
          placeholder="Enter employee ID"
          disabled={!selectedCompany?.id}
          className="w-full px-3 py-2 border rounded-md focus:outline-none bg-[#F3F3F5]"
        />
{selectedemployee && `${selectedemployee.firstname} ${selectedemployee.lastname}`}

        {/* Suggestions dropdown */}
        {suggestions.length > 0 && (
          <ul className="absolute z-10 bg-white border border-gray-200 rounded-md mt-1 w-full max-h-40 overflow-y-auto shadow-lg">
            {suggestions.map((emp) => (
              <li
                key={emp.id}
                className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                onClick={() => {
                  setEmployeeId(emp.empid); // show selected empid
                  setSelectedEmployee(emp); // store employee object
                  setSuggestions([]); // close dropdown
                }}
              >
                {emp.empid} - {emp.firstname} {emp.lastname}
              </li>
            ))}
          </ul>
        )}

        {loading && (
          <p className="text-xs text-gray-400 mt-1">Searching employees...</p>
        )}
      </div>
{/* <div className="flex items-center gap-2 mb-3">
  <input
    id="app-access"
    type="checkbox"
    checked={isAppAccess}
    onChange={(e) => setIsAppAccess(e.target.checked)}
    className="w-4 h-4 cursor-pointer"
  />

  <label
    htmlFor="app-access"
    className="text-sm text-gray-700 cursor-pointer"
  >
    App Access
  </label>
</div> */}


      {/* Submit button */}
      <button
        className={`w-full sm:h-[40px] ${
          isFormValid
            ? "bg-[#0A0A0A] hover:bg-black"
            : "bg-gray-400 cursor-not-allowed"
        } text-white font-medium py-2 px-4 rounded`}
        onClick={() => {
          if (isFormValid) {
           checkemployeeExistance()

          }
        }}
        disabled={!isFormValid}
      >
        Search Employee
      </button>
    </div>
  );
};

export default CompanyDetails;
